module.exports = __webpack_public_path__ + "img/gt.1274b415.svg";